export default __webpack_public_path__ + "static/media/ic-sm-cultivation-2.7776a265.svg";